<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Biosecurity Incident', apiMethod: 'BiosecurityIncidents', form: () => import('../forms/BiosecurityIncidentForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                ],
                mainForm: () => import('../forms/BiosecurityIncidentForm'),
                claimName: 'BiosecurityIncidents',
                apiMethod: 'BiosecurityIncidents',
            }
        }
    };
</script>
